// Configuration file for environment variables
// This will be populated by webpack at build time

declare const __REACT_APP_PUBLIC_API_KEY__: string
declare const __REACT_APP_API_URL__: string

export const config = {
  publicApiKey: __REACT_APP_PUBLIC_API_KEY__ ?? 'Not found',
  apiUrl: __REACT_APP_API_URL__ ?? 'http://localhost:3000'
}